module.exports = __webpack_public_path__ + "static/img/4.acc8b2dc.jpg";